import { useParams } from "react-router-dom";
import PayFlow from "@/components/PayFlow";

export default function PayPage() {
  const { id } = useParams();

  return (
    <main className="relative flex min-h-screen items-center justify-center overflow-hidden px-4 pt-[72px]" data-testid="pay-page">
      <div className="bg-grid absolute inset-0" />
      <div className="animate-glow pointer-events-none absolute -top-40 right-[-10%] h-[560px] w-[560px] rounded-full bg-sgreen/15 blur-[140px]" />
      <div className="relative w-full max-w-md rounded-2xl border border-line bg-card2 p-7 sm:p-9">
        <PayFlow paymentId={id} brand />
        <p className="mt-8 text-center font-mono text-[11px] text-mut">
          Non-custodial · funds move wallet-to-wallet on Solana
        </p>
      </div>
    </main>
  );
}
